import { connect } from 'react-redux'

import { search, setCurrentAddress } from '../../actions/pointOfSale';

import SearchBlock from 'ui-kit/src/components/SearchBlock/SearchBlock';

const mapStateToProps = (state) => {
  return {
    api: state.pointOfSale.api,
    fieldValue: state.pointOfSale.fieldValue,
    geolocateOnLoad: !state.pointOfSale.selectedId && !state.pointOfSale.fieldValue,
    isGeolocationAvailable: state.shared.isGeolocationAvailable,
    placeholder: state.shared.dataCdc && state.shared.dataCdc.search
      ? state.shared.dataCdc.search.placeholder
      : '',
    searchValue: state.pointOfSale.searchValue,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    search: search.bind(null, dispatch),
    setCurrentAddress: setCurrentAddress.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBlock);



// WEBPACK FOOTER //
// ./src/components/StatefulSearchBlock/StatefulSearchBlock.jsx